export default {
  "content": "<path d=\"M13 8l-3-3m3 3l-3 3m3-3H3\" stroke=\"#ff00cb\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "fill": "none",
    "height": "16",
    "width": "16",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};